import { render, staticRenderFns } from "./RoadUsage.vue?vue&type=template&id=d0084b24"
import script from "./RoadUsage.vue?vue&type=script&lang=js"
export * from "./RoadUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports